import { render, staticRenderFns } from "./TeleconsultoMenu.vue?vue&type=template&id=c79ba88e&"
import script from "./TeleconsultoMenu.vue?vue&type=script&lang=js&"
export * from "./TeleconsultoMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports